import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useLanguage } from "../../../../Translations/LenguageContext";
import ErrorMessage from "../../../../Components/ErrorMessage";
import Spinner from "../../../../Components/Spinner";

const AddDomainModal = ({ showAddDomain, closeAddDomain, GetDomains, context }) => {
    const { t } = useLanguage();
    const { project_id } = useParams();
    const user_id = sessionStorage.getItem("user_id");
    const [error, setError] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [returnedDns, setReturnedDns] = useState(null);
    const [returnedSsl, setReturnedSsl] = useState(null);
    const [returnedError, setReturnedError] = useState(null);
    const [customDomain, setCusotmDomain] = useState(null);
    const [type, setType] = useState(null)


    useEffect(() => {
        if (context == "webapp") {
            setType("frontend")
        } else if (context == "serverless") {
            setType("frontend")
        }else if (context == "api") {
            setType("api")
        }else {
            setType(null)
        }
    }, [context])

    const [copied, setCopied] = useState(false);

    const CloseModal = () => {
        closeAddDomain()
        setError({ message: "", display: false });
        setCopied(false)
        setCusotmDomain(null)
        setReturnedError(null)
        setReturnedSsl(null)
        setReturnedDns(null)

    };

    const HandleSave = async () => {
        setLoading(true);
        setError({ message: "", display: false });
        const data = { user_id, project_id, customDomain, type };

        try {
            const response = await fetch("https://aiservice.erioon.com/add_custom_domain", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });

            setLoading(false);

            const result = await response.json();
            if (response.ok) {
                setError({ message: "", display: false });

                setReturnedDns(result.dns);
                setReturnedSsl(result.ssl);
                GetDomains()
            } else {
                setReturnedError(result.error);
                setError({ message: `Domain is not available`, display: true });
            }
        } catch (err) {
            setLoading(false);
            setError({ message: "Failed to save AI settings. Please try again later.", display: true });
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <Modal show={showAddDomain} onHide={CloseModal} className="modal_domain_settings">
            <div className="modal_domain_settings_inner">
                <p className="share_label">Custom {type} domain</p>
                <p className="share_label_desc">
                    Add a custom {type} domain.
                </p>


                {context == "webapp" && (
                    <>
                        <label className="deployment_section_title">Choose domain type</label>
                        <div className="label_input_section">
                            <select
                                disabled={!!returnedDns} // simpler truthy check
                                value={type}              // keep controlled component consistent
                                onChange={(e) => setType(e.target.value)}
                            >
                                <option value="frontend">Frontend</option>
                                <option value="backend">Backend</option>
                                <option value="api">API</option>
                            </select>
                        </div>
                    </>
                )}

                <label className="deployment_section_title">Domain</label>
                <div className="label_input_section">
                    <input
                        disabled={returnedDns ? true : false}
                        placeholder={`www.your-${type}-domain.com`}
                        value={customDomain || ""}
                        onChange={(e) => setCusotmDomain(e.target.value)}
                    />
                </div>

                <div className={`dns_cont ${returnedDns ? "" : "dns_cont_hidden"}`}>
                    {returnedDns ? (
                        <div className="dns_cont_record_table fade-in">
                            <div className="dns_cont_record">
                                <div className="dns_cont_record_cell_first dns_cont_header_cell">Type</div>
                                <div className="dns_cont_record_cell_second_copy dns_cont_header_cell">Value</div>
                            </div>
                            <div className="dns_cont_record">
                                <div className="dns_cont_record_cell_first">CNAME</div>
                                <div className="dns_cont_record_cell_second_copy">
                                    {returnedDns}{" "}
                                    <i
                                        className={`fa-solid ${copied ? "fa-check" : "fa-copy"}`}
                                        onClick={() => handleCopy(returnedDns)}
                                        style={{ cursor: "pointer", marginLeft: "6px" }}
                                        title="Copy DNS record"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>DNS record will appear here</>
                    )}
                </div>

                <div className="ai_settings_cont_modal_footer">
                    <ErrorMessage err={error} />
                    <div className="footer_btn_cont">
                        {!returnedDns && (    
                            <button className="save_btn" onClick={HandleSave} disabled={returnedDns ? true : false}>
                            {loading ? <Spinner loading={loading} /> : t.save}
                        </button>
                        )}
                        <button className="cancel_btn" onClick={CloseModal}>
                            {t.cancel}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddDomainModal;
